import { AppService, AppError } from "@/services/app.service";

const state = {
  loading: false,
  countries: [],
  currencies: [],
  time_zones: [],
  banks: [],
  states: [],
  lgas: [],
  serverResponse: null,
  fileUploadData: {}
};

const getters = {
  loading: state => {
    return state.loading;
  },

  countries: state => {
    return state.countries;
  },

  currencies: state => {
    return state.currencies;
  },

  time_zones: state => {
    return state.time_zones;
  },

  banks: state => {
    return state.banks;
  },

  states: state => {
    return state.states;
  },

  lgas: state => {
    return state.lgas;
  },

  serverResponse: state => {
    return state.serverResponse;
  },
  fileUploadData: state => {
    return state.fileUploadData;
  }
};

const actions = {
  async pull({ commit }) {
    commit("startRequest");
    try {
      const response = await AppService.pull();
      commit("pullAllSuccess", response);
    } catch (e) {
      if (e instanceof AppError) {
        commit("stopRequest", { status: e.errorCode, message: e.message });
      }

      return false;
    }
  },

  async fetchBanks({ commit }, { countryId }) {
    commit("startRequest");
    try {
      const response = await AppService.fetchBanks(countryId);
      commit("pullBankSuccess", response);
    } catch (e) {
      if (e instanceof AppError) {
        commit("stopRequest", { status: e.errorCode, message: e.message });
      }

      return false;
    }
  },

  async fetchStates({ commit }, { countryId }) {
    commit("startRequest");
    try {
      const response = await AppService.fetchStates(countryId);
      commit("pullStateSuccess", response);
    } catch (e) {
      if (e instanceof AppError) {
        commit("stopRequest", { status: e.errorCode, message: e.message });
      }

      return false;
    }
  },

  async fetchLgas({ commit }, { countryId, stateId }) {
    commit("startRequest");
    try {
      const response = await AppService.fetchLgas(countryId, stateId);
      commit("pullLgaSuccess", response);
    } catch (e) {
      if (e instanceof AppError) {
        commit("stopRequest", { status: e.errorCode, message: e.message });
      }

      return false;
    }
  },

  async requestFileUploadData({ commit }) {
    commit("startRequest");
    try {
      const response = await AppService.requestFileUploadData();
      console.log("file data store", response);
      commit("requestFileUploadDataSuccess", response);
      return response;
    } catch (e) {
      if (e instanceof AppError) {
        commit("stopRequest", { status: e.errorCode, message: e.message });
      }

      return false;
    }
  }
};

const mutations = {
  startRequest(state) {
    state.loading = true;
    state.serverResponse = null;
  },

  pullAllSuccess(state, response) {
    state.currencies = response.currencies;
    state.countries = response.countries;
    state.time_zones = response.time_zones;
    state.loading = false;
  },

  pullBankSuccess(state, response) {
    state.banks = response.banks;
    state.loading = false;
  },

  pullStateSuccess(state, response) {
    state.states = response.states;
    state.loading = false;
  },

  requestFileUploadDataSuccess(state, response) {
    state.fileUploadData = response;
    state.loading = false;
  },

  pullLgaSuccess(state, response) {
    state.lgas = response.lgas;
    state.loading = false;
  },

  stopRequest(state, response) {
    state.loading = false;
    state.serverResponse = response;
  }
};

export const app = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
